export const allCourses = [
  {
    _id: 1,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Frame-89.jpg?resize=600%2C550&ssl=1",
    title: "PostgreSQL to’liq qo’llanma",
    type: "O'rta",
    lessons: "27",
    author: "Bexruz Xolmuminov",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/200x200-1.jpg?resize=150%2C150&ssl=1",
    price: "Bepul",
  },
  {
    _id: 2,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/kotlin-asoslari.jpg?resize=600%2C550&ssl=1",
    title: "Kotlin dasturlash tili.",
    type: "Barcha uchun",
    lessons: "41",
    author: "Zohidjon Akbarov",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/1-2-1.png?resize=150%2C150&ssl=1",
    price: "Bepul",
  },
  {
    _id: 3,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Frame-49-2.jpg?resize=600%2C550&ssl=1",
    title: "Professional Node.JS. Noldan e’lonlar saytini yaratamiz",
    type: "O'rta",
    lessons: "60",
    author: "Bexruz Xolmuminov",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/200x200-1.jpg?resize=150%2C150&ssl=1",
    price: "247,000 UZS",
  },
  {
    _id: 4,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/frontend.jpg?resize=600%2C550&ssl=1",
    title: "Frontend dasturlash asoslari. Saralash",
    type: "Boshlang'ich",
    lessons: "112",
    author: "Muhammadjavohirbek Sur'atov",
    authorImage:
      "https://secure.gravatar.com/avatar/ba7c731370790d2ec6431ed7ff3df7dc?s=300&d=mm&r=g",
    price: "Bepul",
  },
  {
    _id: 5,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Toliq-ReactJS-kursi.jpg?resize=540%2C330&ssl=1",
    title: "ReactJS, Redux, NextJS & GraphQL To’liq Kurs. Real Loyihalar",
    type: "Boshlang'ich",
    lessons: "140",
    author: "Samar Badrullayev",
    price: "247,000 UZS",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/07/photo_2021-07-01_18-45-37.jpg?resize=150%2C150&ssl=1",
  },
  {
    _id: 6,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Mukhammad-Ermatov.png?resize=600%2C550&ssl=1",
    title: "Django Rest Framework darslari",
    type: "O'rta",
    lessons: "11",
    author: "Mukhammad Ermatov",
    price: "Bepul",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/photo_2021-07-23_13-48-38-3.jpg?resize=150%2C150&ssl=1",
  },
  {
    _id: 7,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Frame-48.jpg?resize=600%2C550&ssl=1",
    title: "Mukammal Telegram Bot",
    type: "O'rta",
    lessons: "84",
    author: "Anvar Narzullaev",
    price: "247,000 UZS",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/05/tg-logo2.png?resize=150%2C150&ssl=1",
  },
  {
    _id: 8,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/PHP-dasturlash-asoslari.jpg?resize=600%2C550&ssl=1",
    title: "PHP dasturlash asoslari",
    type: "O'rta",
    lessons: "25",
    author: "Ahmadjon Xashimov",
    price: "167,000 UZS",
    authorImage:
      "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/07/bb.jpg?resize=150%2C150&ssl=1",
  },
  {
    _id: 9,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Git-boshqaruv-tizimi-kursi.jpg?resize=600%2C550&ssl=1",
    title: "Git versiya boshqaruv tizimi",
    type: "O'rta",
    lessons: "4",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 10,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Typescript-asoslari.jpg?resize=600%2C550&ssl=1",
    title: "TypeScript asoslari",
    type: "O'rta",
    lessons: "13",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 11,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Docker-kursi.jpg?resize=600%2C550&ssl=1",
    title: "Docker haqida batafsil",
    type: "O'rta",
    lessons: "9",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 12,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/TensorflowJS-ga-kirish.jpg?resize=600%2C550&ssl=1",
    title: "TensorFlow.js ga kirish",
    type: "Yuqori",
    lessons: "8",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 13,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/SOLID-tamoyillari-haqida.jpg?resize=600%2C550&ssl=1",
    title: "SOLID Tamoyillari",
    type: "O'rta",
    lessons: "6",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 14,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Go-dasturlash-tili-asoslari.jpg?resize=600%2C550&ssl=1",
    title: "GO dasturlash tili",
    type: "O'rta",
    lessons: "14",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
  {
    _id: 15,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/ASP-net-core-kursi.jpg?resize=600%2C550&ssl=1",
    title: "ASP .Net Core MVC – batafsil",
    type: "O'rta",
    lessons: "41",
    author: "Farhod Dadajonov",
    price: "Bepul",
    authorImage:
      "https://secure.gravatar.com/avatar/4829ade6851b512925cc53226b8ea048?s=300&d=mm&r=g",
  },
];
